module.exports = __webpack_public_path__ + "static/media/ymca_community_center_mural_concept_2018.f64cd0cf.webp";